import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding'
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'

import { setMapPosition } from '../redux/mapSlice'
import { switchStyle } from '../redux/mapStyleSlice'

import { logo, logoColor } from '../assets/images'
import SearchBar from './SearchBar'

mapboxgl.accessToken =
  'pk.eyJ1IjoicGxhbmV0d2F0Y2hzYXMiLCJhIjoiY2xpMWtvMDFqMDluZjNzbzdtaHVoNXA1OSJ9.gr5ajbSzwQWk8WC-HH1Csg'

const geocodingClient = mbxGeocoding({ accessToken: mapboxgl.accessToken })

const Header = ({ onPlaceSelected, mapRef }) => {
  const [selectedPlace, setSelectedPlace] = useState(null)
  const dispatch = useDispatch()
  const theme = useSelector((state) => state.mapStyle.darkMode ? 'dark' : 'light')
  const darkMode = useSelector((state) => state.mapStyle.darkMode)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  useEffect(() => {
    dispatch(switchStyle())
  }, [darkMode, dispatch])

  const handlePlaceSelect = (place) => {
    if (onPlaceSelected) {
      onPlaceSelected(place.center)
    }

    if (mapRef && place) {
      mapRef.current.flyTo({
        center: place.center,
        zoom: 12,
        speed: 0.6,
        curve: 0.9,
        essential: true
      })

      mapRef.current.on('moveend', () => {
        dispatch(setMapPosition({ center: place.center, zoom: 12 }))
      })
    }

    setSelectedPlace(place)
    setDropdownOpen(false)
    setSelectedPlace(null)
  }

  return (
    <header className='sm:flex-nowrap flex-wrap absolute w-full p-3 flex justify-between'>
      <div className='ml-20 flex items-center'>
        <img src={theme === 'dark' ? logo : logoColor} alt='Logo' className='h-8 mr-2' />
      </div>
      <div className='relative flex justify-center w-full items-center'>
        <SearchBar
          handlePlaceSelect={handlePlaceSelect}
          geocodingClient={geocodingClient}
          setDropdownOpen={setDropdownOpen}
          dropdownOpen={dropdownOpen}
          selectedPlace={selectedPlace}
          theme={theme}
        />
      </div>
    </header>
  )
}

export default Header
